module.exports = __webpack_public_path__ + "static/img/sec 10.c01eb3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/sec 10.png
// module id = sgZI
// module chunks = 12